// extracted by mini-css-extract-plugin
module.exports = {"flagGroup":"FlagGroup_flagGroup__3yMk5","checkmark":"FlagGroup_checkmark__FKEjo"};